<template>
    <div>
        <h1>
        {{ $t('commute.title.vehicle') }}
        
        </h1>
            <small v-responsive.lg.xl.md >
            {{ $t('commute.title.vehicle.note1') }} 
            </small>
        <RadioGroup
            v-model="vehicle"
            name="vehicle"
            :change="notify_parent()"
            :div_classes=bootstrap_div_classes
            :default_val="vehicle" :items=vehicles />
    
        <div v-if="['other'].includes(vehicle)" >
            <br>
            <select-list
                v-model="other_vehicle"
                name="other_vehicle"
                :change="notify_parent()"
                :div_classes=bootstrap_div_classes
                :default_val="other_vehicle" :items=other_vehicles >
            </select-list>
        </div>

    </div>    
</template>

<script>
    import RadioGroup from './RadioGroup.vue'
    import SelectList from './SelectList.vue'
    import ConvertedNumber from './ConvertedNumber.vue'

    import Vehicles from '../mixins/Vehicles.js'
    import Persistent from '../mixins/Persistent.js'

    export default {
        mixins: [Vehicles, Persistent],
        components: {
            RadioGroup,SelectList,
            ConvertedNumber
        },
        data: function(){
            return {
                other_vehicle : "",
                vehicle : "",
            }
        },
        watch : {
        },
        computed : {
            bootstrap_div_classes : () => {
                return "dbtn-group dbtn-group-toggle capitalize"
            },
        },
        methods: {

        }
    }
    

</script>

<style>
</style>